export const addNewUserSuccess = 'ADD_NEW_USER_SUCCESS';
export const addNewUserFail = 'ADD_NEW_USER_FAIL';
export const editExistingUserSuccess = 'EDIT_EXISTING_USER_SUCCESS';
export const editExistingUserFail = 'EDIT_EXISTING_USER_FAIL';
export const deleteExistingUserSuccess = 'DELETE_EXISTING_USER_SUCCESS';
export const deleteExistingUserFail = 'DELETE_EXISTING_USER_FAIL';
export const getAllSupervisorsSuccess = 'GET_ALL_USERS_SUCCESS';
export const getAllSupervisorsFail = 'GET_ALL_USERS_FAIL'